import styled from "styled-components";

export const ClassDetailTopicsContainer = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

export const ClassDetailHeading = styled.h3`
  margin: 16px 0;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  color: ${({ theme }) => theme.colors.black};
  line-height: 1.3;
`;

export const ClassDetailInfoItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
export const ClassDetailInfoItem = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  color: ${({ theme }) => theme.colors.neutral[600]};
  margin: 0;
  &:not(:last-child) {
    &:after {
      content: "•";
      margin: 0 4px;
      font-size: ${({ theme }) => theme.fontSizes["md"]};
      color: ${({ theme }) => theme.colors.neutral[600]};
    }
  }
`;

export const ClassDetailCTAWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
`;

export const ClassDetailProgressContainer = styled.div`
  width: 100%;
`;

export const ClassDetailProgressBarContainer = styled.div`
  width: 100%;
  height: 8px;
  position: relative;
  background: ${({ theme }) => theme.colors.green[100]};
  border-radius: 24px;
  overflow: hidden;
`;

export const ClassDetailProgressBarActive = styled.div<{ value: number }>`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: ${({ value }) => `${value}%`};
  background-color: ${({ theme }) => theme.colors.green[600]};
`;
export const ClassDetailProgressMessage = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  color: ${({ theme }) => theme.colors.green[600]};
  font-weight: bold;
  white-space: nowrap;
  margin: 0 0 8px 0;
`;

export const ClassDetailTeacherBlock = styled.div`
  padding: 32px 0;
  border-top: 1px solid ${({ theme }) => theme.colors.neutral[100]};
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const ClassDetailTeacherImageWrapper = styled.figure`
  margin: 0;
  position: relative;
  width: 64px;
  height: 64px;
  border-radius: 4px;
  overflow: hidden;
`;

export const ClassDetailTeacherDetails = styled.div``;
export const ClassDetailsTeacherName = styled.p`
  margin: 0 0 4px 0;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: bold;
  color: ${({ theme }) => theme.colors.black};
  display: flex;
  align-items: center;
`;
export const ClassDetailsTeacherUniversity = styled.p`
  margin: 0 0 4px 0;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.colors.neutral[600]};
`;

export const ClassDetailsDescriptionBlock = styled.div`
  margin: 0;
  background: ${({ theme }) => theme.colors.green[100]};
  padding: 0 16px 16px 16px;
  border-radius: 8px;
  overflow: hidden;
`;

export const ClassDetailsDescriptionBlockHeading = styled.h4`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  font-weight: bold;
  color: ${({ theme }) => theme.colors.black};
`;

export const ClassDetailsDescriptionBlockDesc = styled.div`
  /* Need to direct target html elements as we are getting html from BE */
  p {
    margin: 0;
    font-family: ${({ theme }) => theme.fonts.secondary};
    font-size: ${({ theme }) => theme.fontSizes.md};
    color: currentColor;
  }
  color: ${({ theme }) => theme.colors.neutral[600]};
`;

export const ClassDetailLiveTag = styled.div`
  display: inline-block;
  text-transform: uppercase;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-family: ${({ theme }) => theme.fonts.primary};
  line-height: 1;
  padding: 6px;
  color: ${({ theme }) => theme.colors.magenta[500]};
  background-color: ${({ theme }) => theme.colors.magenta[100]};
  font-weight: bold;
  letter-spacing: 1px;
  border-radius: 3px;
  &:before {
    content: "•";
    display: inline-block;
  }
`;

export const ClassDetailUpcomingTimer = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  color: ${({ theme }) => theme.colors.neutral[600]};
  font-weight: bold;
  margin: 0;
`;

export const ClassDetailUpcomingTimerHighlight = styled.span`
  color: ${({ theme }) => theme.colors.brand[500]};
  background: ${({ theme }) => theme.colors.yellow[200]};
  border-radius: 4px;
  padding: 2px 4px;
`;

export const ClassDetailUpcomingTimerDots = styled.span`
  color: ${({ theme }) => theme.colors.brand[500]};
  margin: 0 4px;
`;
